import { render, staticRenderFns } from "./ExportarAgGridButton.vue?vue&type=template&id=4c2651fe&"
import script from "./ExportarAgGridButton.vue?vue&type=script&lang=ts&"
export * from "./ExportarAgGridButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c2651fe', component.options)
    } else {
      api.reload('4c2651fe', component.options)
    }
    module.hot.accept("./ExportarAgGridButton.vue?vue&type=template&id=4c2651fe&", function () {
      api.rerender('4c2651fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/ExportarAgGridButton.vue"
export default component.exports